query allOperators {
  allOperators {
    operators: nodes {
      operatorId
      productHealthStatuses: productHealthStatusesByOperatorId {
        nodes {
          overrideStatus
          product
          productStatus
        }
      }
    }
  }
}
